export default __webpack_public_path__ + "1.19.2/static/media/sad-file.c68aeff0.svg";